import { httpApi } from '@app/api/http.api';
import {
  ActivityLog,
  ActivityLogPaginatedResponse,
  ActivityLogFilters,
} from '@app/types/api.types';

export const getActivityLogs = (filters?: ActivityLogFilters): Promise<ActivityLogPaginatedResponse> =>
  httpApi
    .get<ActivityLogPaginatedResponse>('/activity-logs', { params: filters })
    .then(({ data }) => data);

export const getActivityLogsByUser = (userId: string, params?: { page?: number; limit?: number }): Promise<ActivityLogPaginatedResponse> =>
  httpApi
    .get<ActivityLogPaginatedResponse>(`/activity-logs/user/${userId}`, { params })
    .then(({ data }) => data);

export const getActivityLogsByResource = (
  resourceType: string,
  resourceId: string,
  params?: { page?: number; limit?: number }
): Promise<ActivityLogPaginatedResponse> =>
  httpApi
    .get<ActivityLogPaginatedResponse>(`/activity-logs/resource/${resourceType}/${resourceId}`, { params })
    .then(({ data }) => data);

